'use client'

import { useTranslation } from 'src/utils/i18n'
import Image from 'next/image'
import Link from 'next/link'
import Icon from 'src/@core/components/icon'
import React, { useEffect, useRef, useState } from 'react'
import { Carousel, QRCode } from 'antd'
import { MessageInfo } from 'src/components/pop-up-window'
import { appendSetupQuery } from 'src/utils/resolveCurrentOrderId'

const GOOGLE_VERIFICATION_APK_URL = process.env.NEXT_PUBLIC_GOOGLE_CLOUD_APK_URL || 'https://italk.cc/6'

const Start = (data) => {
  const { t } = useTranslation('commonAndroid')

  const step = [
    {
      title: t("Copy the link into your Android phones browser or scan this QR code to visit the download page"),
      img: '/images/android/icloud/step1.webp'
    },
    {
      title: t('Download Google Account Verification If a pop-up warning appears tap Download anyway'),
      img: '/images/android/icloud/step2.webp'
    },
    {
      title: t("Install and open the app"),
      img: '/images/android/icloud/step3.webp'
    }
  ]

  // 复制文本
  async function copy() {
    try {
      await navigator.clipboard.writeText(GOOGLE_VERIFICATION_APK_URL)
      MessageInfo({ content: t('Copied successfully'), type: 'success' })
    } catch { }
  }

  const [autoplay, setAutoplay] = useState(true)

  useEffect(() => {
    const handleClick = event => {
      if (window.innerWidth < 600) {
        setAutoplay(false)

        setTimeout(() => {
          setAutoplay(true)
        }, [5000])
      }
    }

    // 添加点击事件监听器
    document.addEventListener('click', handleClick)

    // 添加滑动事件监听器
    document.addEventListener('scroll', handleClick)

    // 在组件卸载时移除事件监听器
    return () => {
      document.removeEventListener('click', handleClick)
      document.removeEventListener('scroll', handleClick)
    }
  }, [autoplay]) // 空数组表示只在组件加载和卸载时运行

  const [currentSlide, setcurrentSlide] = useState(0)

  const onChange = currentSlide1 => {
    setcurrentSlide(currentSlide1)
  }

  const imgToggle = useRef()

  const Handler = index => {
    if (index !== 3) {
      imgToggle.current.goTo(index)
    } else {
      imgToggle.current.goTo(0)
    }
  }

  const StepProgress = ({ current = 1, total = 2 }) => {
    const barWidth = 72 // 宽度

    return (
      <div className="flex items-center justify-center gap-4 mb-[40px] Mlg:mb-[20px]">
        <div className="text-[20px] leading-[30px] font-medium text-[#484B60] Mlg:text-[16px] Mlg:leading-[24px] ">
          {current}/{total}
        </div>

        <div className="flex gap-x-[6px]">
          {Array.from({ length: total }).map((_, i) => {
            const active = i < current;

            return (
              <div
                key={i}
                className="h-[4px] w-[72px] rounded-[1px]"
                style={
                  active
                    ? {
                      background: "linear-gradient(90deg, #09A6EA 1.56%, #6838F2 47.99%)",
                      backgroundSize: `${current * barWidth}px 4px`,
                      backgroundPosition: `-${i * barWidth}px 0px`,
                    }
                    : {
                      background: "#E8EDFF",
                    }
                }
              />
            )
          })}
        </div>
      </div>
    )
  }

  return (
    <div className='flex flex-col items-center smj:pb-[40px]'>
      {data.fullScreen && (
        <Icon onClick={() => { data.setFullScreen(false) }}
          icon='maki:cross'
          className={`absolute top-2 right-3 w-[20px] h-[20px] text-black/30`}
        />
      )}
      <StepProgress />
      <div className={`max-w-[722px] flex justify-between items-center ${data.fullScreen && 'flex-col'}`}>
        <div className={`max-w-[450px] ${data.fullScreen && 'order-2 pb-5'}`}>
          <p className='text-[24px] Dsm:text-[20px] text-[#2B2D33] mx-auto font-[600] Dsm:text-center'>
            {t('Download Google Cloud Verification on your own Android')}
          </p>
          <div className='flex flex-col items-center mt-[32px]'>
            <div className='rounded-[10px] bg-white p-[4px]' style={{ boxShadow: 'rgba(76, 78, 100, 0.22) 0px 10px 17px 6px' }}>
              {process.env.NEXT_PUBLIC_GOOGLE_CLOUD_APK_URL ? (
                <QRCode value={GOOGLE_VERIFICATION_APK_URL} size={90} bordered={false} />
              ) : (
                <Image
                  src='/images/login/app.png'
                  width={90}
                  height={90}
                  alt='qr'
                  className='rounded-[10px]'
                />
              )}
            </div>
            <div
              className='w-max min-h-[26px] rounded-[4px] bg-[#F0F3F4] text-[#676CF6] text-[14px] px-[8px] flex justify-between items-center gap-2 mt-4'
              style={{ maxWidth: 'min(450px, calc(100vw - 48px))' }}
            >
              <Link
                href={GOOGLE_VERIFICATION_APK_URL}
                target='_blank'
                rel='noreferrer'
                className='min-w-0 break-all leading-5'
              >
                {process.env.NEXT_PUBLIC_GOOGLE_CLOUD_APK_URL || 'italk.cc/6'}
              </Link>
              <Image
                src='/images/android/setup/copy.svg'
                width={15}
                height={0}
                alt='copy'
                className='flex-shrink-0 cursor-pointer'
                onClick={copy}
              />
            </div>
          </div>
          <div
            onMouseEnter={() => {
              if (window.innerWidth > 600) {
                setAutoplay(false)
              }
            }}
            onMouseLeave={() => {
              if (window.innerWidth > 600) {
                setAutoplay(true)
              }
            }}
            className={`${data.fullScreen ? '' : 'Dsm:w-[96%] mx-auto'}`}
          >
            {step.map((item, index) => {
              return (
                <div
                  onClick={() => Handler(index)}
                  key={index}
                  className={`flex text-[14px] cursor-pointer text-black mt-[10px]`}>
                  <p className={`w-[24px] h-[22px] rounded-full flex items-center justify-center mt-[2px] ${currentSlide === index && 'bg-[#2A99FF] text-white'}`}>
                    {index + 1}.
                  </p>
                  <div className={`ml-1 w-[100%] mt-[2px] text-[15px]`}
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
              )
            })}
          </div>
        </div>
        <div
          className={`w-[222px] ml-[50px] Dsm:m-0 h-auto relative ${data.fullScreen ? 'order-1 mx-auto pb-5' : 'Ssm:hidden'
            }`}
        >
          <Carousel
            waitForAnimate={true}
            autoplay={autoplay}
            className='flex overflow-hidden w-[227px] h-auto'
            ref={imgToggle}
            cancelable={false}
            afterChange={onChange}
          >
            {step.map((item, index) => {
              return (
                <div key={index} className=''>
                  <Image
                    alt='img'
                    width={100}
                    height={100}
                    src={item.img}
                    className='mx-auto w-[207px] h-[447px] rounded-[15px]'
                  />
                </div>
              )
            })}
          </Carousel>
          <div className='flex items-center justify-center mt-6'>
            {step.map((item, index) => {
              return (
                <div
                  onClick={() => Handler(index)}
                  key={index}
                  className={`border-[1px] ${index !== 0 && 'ml-2'
                    } border-[#2A99FF] w-[12px] h-[12px] cursor-pointer rounded-[15px] ${currentSlide === index && 'bg-[#2A99FF]'
                    } `}
                ></div>
              )
            })}
          </div>
        </div>
      </div>
      <div className={`flex flex-col items-center Smd:hidden ${data.fullScreen && 'hidden'} mb-4`} onClick={() => data.setFullScreen(true)}>
        <Image
          src='/images/bind/watch.svg'
          width={100}
          height={100}
          alt='img'
          className='mx-auto w-[58px] mt-[36px]'
        />
        <p className='mt-[14px] text-[14px] text-[#454CFF] font-[600]'>{t('Watch a tutorial')}</p>
      </div>

      <div className='w-full mx-auto border-t-[1px] border-[#E5E7EB] bg-white fixed bottom-0'>
        <div className='flex justify-center w-full p-5 Mlg:px-0 bg-white mx-auto'>
          <div className='w-full lg:w-[620px] flex justify-between smj:px-4'>
            <button onClick={() => { window.location.assign(appendSetupQuery('/android/classification')) }}
              className='border-[1px] border-[#454CFF] bg-white rounded-[24px] h-[35px] flex items-center pl-[10px] pr-[19px]'>
              <Image className='mr-[7px]' src='/images/android/setup/back.svg' width={18} height={18} alt='back' />
              <span className='text-[15px] text-[#454CFF] font-[600]'>{t('BACK')}</span>
            </button>

            <button
              onClick={() => { data.setCurrentItem('App') }}
              className={`border-0 bg-[#FFCF55] rounded-[41px] h-[35px] text-[15px] flex items-center pl-[24px] pr-[10px]`}
            >
              <span className='text-[15px] text-[#1B1C2B] font-[600]'>{t('NEXT')}</span>
              <Image className='ml-[6px]' src='/images/android/setup/right.svg' width={18} height={18} alt='right' />
            </button>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Start
